import { Component, Input } from '@angular/core';
import { AbstractAuditDto, AuditGroupDto } from '../../../service/dto';

@Component({
  selector: 'app-audit-timeline-group',
  standalone: false,
  templateUrl: './audit-timeline-group.component.html',
  styleUrl: './audit-timeline-group.component.scss'
})
export class AuditTimelineGroupComponent {
	@Input() audit!: AuditGroupDto;

	getSubType(){
		return (this.audit as AuditGroupDto).subType;
	}
	getItems(){
		return (this.audit as AuditGroupDto).items;
	}
	getAsGroup(input: AbstractAuditDto):AuditGroupDto{
		return input as AuditGroupDto;
	}
}
